import type { Address } from '@/types/Models/Customer'

export default class SenderAddressTransformer {
  /**
   * Method used to transform a fetched account.
   */
  static fetch(data: Address): Address {
    return {
      ...data,
      handle: data.id,
      label: `${data.companyName}, ${data.countryCode}, ${data.city}, ${data.coAddress || data.addressLine}`,
    } as Address
  }

  /**
   * Method used to transform a fetched collection.
   */
  static fetchCollection(items: any[]): Address[] {
    return items.map((item) => this.fetch(item))
  }
}
